import classNames from "classnames";
import { useCallback, useState } from "react";

import OnBoardingStepper from "./onBoardingStepper";
// saveSlider
import saveSliderStyles from "./saveSlider.module.scss";
// components
import First from "./steps/first";
import Fourth from "./steps/fourth";
import Second from "./steps/second";
import Third from "./steps/third";

export enum OnboardingType {
  LARGE = "LARGE",
  SMALL = "SMALL",
}

interface Props {
  type?: OnboardingType;
  onClose: any;
}

const SaveSlider: React.FC<Props> = ({
  type = OnboardingType.LARGE,
  onClose,
}: Props) => {
  const [page, setPage] = useState(1);

  const PageDisplay = useCallback(() => {
    switch (page) {
      case 1:
        return <First type={type} />;
      case 2:
        return <Second type={type} />;
      case 3:
        return <Third type={type} />;
      case 4:
        return <Fourth type={type} />;
      default:
        return <Fourth type={type} />;
    }
  }, [page, type]);

  const onNext = () => {
    if (page === 4) {
      setPage(1);
    } else {
      setPage((currentPage) => currentPage + 1);
    }
  };
  const onPrev = () => {
    if (page === 1) {
      setPage(4);
    } else {
      setPage((currentPage) => currentPage - 1);
    }
  };

  return (
    <div
      className={classNames(
        type === OnboardingType.SMALL
          ? saveSliderStyles.smaller_outer_container
          : saveSliderStyles.outter_container
      )}>
      <img
        className={saveSliderStyles["close-image"]}
        onClick={onClose}
        src="/assets/images/slider/close.svg"
      />
      {PageDisplay()}
      <OnBoardingStepper
        steps={4}
        activeStep={page}
        onNext={onNext}
        onPrev={onPrev}
      />
    </div>
  );
};

export default SaveSlider;
